import { render, staticRenderFns } from "./invoiceDetail.vue?vue&type=template&id=140c6516&scoped=true&"
import script from "./invoiceDetail.vue?vue&type=script&lang=js&"
export * from "./invoiceDetail.vue?vue&type=script&lang=js&"
import style0 from "./invoiceDetail.vue?vue&type=style&index=0&id=140c6516&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140c6516",
  null
  
)

export default component.exports